import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Field, change } from 'redux-form';
import { useDispatch } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';
import DurationCustomComponent from '../DurationField/DurationCustomComponent';
import * as _ from 'es-toolkit';

import './BookingPolicyField.css';

const BookingPolicyField = ({ name, form, defaultValue, _predefinedValues }) => {
    const { t }    = useTranslation();
    const dispatch = useDispatch();

    const [sign, setSign] = useState(defaultValue?.toString().charAt(0) === '-' ? '-' : '+');

    useEffect(() => {
        if (_.isBoolean(defaultValue))
            dispatch(change(form, name, 'P0Y0M0DT0M0S'));
    }, [defaultValue, dispatch, form, name]);

    const questions = [
        { value: '+', text: t('settings.pos.booking_policy_question_positive') },
        { value: '-', text: t('settings.pos.booking_policy_question_negative') }
    ].map(v => ({
        text: v.text,
        key: v.value,
        value: v.value
    }));

    // show only minutes and hours
    const onlyParts = ['X', 'H'];

    return (
        <div className="BookingPolicyField">
            <div className="row">
                <div className="col-12 col-lg-2">
                    <div className="d-flex h-100 align-items-center">
                        { t('settings.pos.booking_policy_allow_until') }
                    </div>
                </div>
                <div className="col-12 col-lg-5">
                    <Field
                        className="form-control"
                        name={ name }
                        component={ DurationCustomComponent }
                        onlyParts={onlyParts}
                        noGoBack
                        sign={ sign }
                    />
                </div>
                <div className="col-12 col-lg-5">
                    <Dropdown
                        className="form-control"
                        options={ questions }
                        onChange={ (e, data) => { setSign(data.value); }}
                        value={ sign }
                        search
                        selection
                    />
                </div>
            </div>
        </div>
    );
}

export default BookingPolicyField;
